import { render, staticRenderFns } from "./LeadKanban.vue?vue&type=template&id=29697dc1&scoped=true"
import script from "./LeadKanban.vue?vue&type=script&lang=js"
export * from "./LeadKanban.vue?vue&type=script&lang=js"
import style0 from "./LeadKanban.vue?vue&type=style&index=0&id=29697dc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29697dc1",
  null
  
)

export default component.exports